import { useState } from 'react';
import { Col, Row } from '../components/custom';

import { MailRounded, CheckCircleOutlineRounded } from '@mui/icons-material';

export default function Contact()
{
    const email = 'contact@viztexa.com';
    // const email = 'q2lens@gmail.com';

    const [copyState, setCopyState] = useState(<Row className='alert'>Click to copy Email</Row>);
    const [submitState, setSubmitState] = useState('Send Message');

    function copyEmail()
    {
        navigator.clipboard.writeText(email);

        setCopyState(() =>
        {
            return (
                <Row className='alert'>
                    <CheckCircleOutlineRounded/>
                    <span>Copied!</span>
                </Row>
            );
        });

        setTimeout(() => setCopyState(<Row className='alert'>Click to copy Email</Row>), 1000);
    };

    async function handleSubmit(E)
    {
        E.preventDefault();

        setSubmitState('Sending ...');

        const incomingMessage = {};

        const { target: form } = E;

        for (let i = 0; i < form.length - 1; i++) incomingMessage[form[i].name] = form[i].value;

        incomingMessage.subject = `[Q2LENS] ${incomingMessage.subject}`;

        // const response = await fetch('/contact', {method: 'POST', body: JSON.stringify(incomingMessage), headers: {'content-type': 'application/json'}});

        const response = await fetch('https://app.viztexa.com/api/contact', {method: 'POST', body: JSON.stringify(incomingMessage), headers: {'content-type': 'application/json'}});

        if (response.ok) return setSubmitState('Thank you for your message !');

        setSubmitState('Error | Please try again later');
    }

    return (
        <Row id='contact'>
            <Col className='left'>
                <span className='title'>Contact Us</span>
                <span className='descsmall'>We'd love to hear from you! We'll get back to you as soon as possible.</span>
                {/* <button id='emailid' onClick={copyEmail}>
                    <Col className='mailIcon'><MailRounded/></Col>
                    <Col>
                        <span className='descsmall'>Mail us at</span>
                        <span className='descsmall email'>{email}</span>
                    </Col>
                    {copyState}
                </button> */}
            </Col>
            <Col className='right'>
                <span className='desc'>Send us a message!</span>
                <form onSubmit={handleSubmit}>
                    <input type='text' name='name' placeholder='Full Name' required/>
                    <input type='email' name='email' placeholder='Email Address' required/>
                    <input type='text' name='subject' placeholder='Subject' required/>
                    <textarea name='message' placeholder='Your Message' required/>
                    <input type='submit' value={submitState}/>
                </form>
            </Col>
        </Row>
    )
}